import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/mail_open_gray_180.png'
import _imports_1 from '@/assets/leaf-with-shadow.png'
import _imports_2 from '@/assets/icons/person_gray_150.png'
import _imports_3 from '@/assets/icons/everyone_500.png'


const _withScopeId = n => (_pushScopeId("data-v-0dfaad5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-message"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Oops, different person", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "This invitation is for someone else.", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Already accepted!", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 3,
  class: "confirm-address"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Invitation", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning" }, " This invitation does not match your account. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Invitation sent to", -1))
const _hoisted_13 = { class: "input-value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Your account", -1))
const _hoisted_15 = { class: "input-value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "instruction" }, [
  /*#__PURE__*/_createTextVNode(" You should continue only if "),
  /*#__PURE__*/_createElementVNode("b", null, "both"),
  /*#__PURE__*/_createTextVNode(" addresses belong to you. ")
], -1))
const _hoisted_17 = { class: "actions" }
const _hoisted_18 = {
  key: 4,
  class: "accept"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "accept-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "mail"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "leaf"
  })
], -1))
const _hoisted_20 = { class: "title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, " You're invited! ", -1))
const _hoisted_22 = { class: "recipient" }
const _hoisted_23 = { class: "sender" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_25 = { class: "sender-email" }
const _hoisted_26 = { class: "family-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Invites you to explore your family tree with this group: ", -1))
const _hoisted_28 = { class: "invite-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_30 = { class: "item-body" }
const _hoisted_31 = { class: "item-title" }
const _hoisted_32 = { class: "item-subtitle" }
const _hoisted_33 = {
  key: 0,
  class: "profile"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "You'll be joining the group as:", -1))
const _hoisted_35 = { class: "invite-item" }
const _hoisted_36 = {
  key: 1,
  class: "expired"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-primary" }, " Your invitation link has expired. To continue, we'll need to send you an updated invitation with a new link. ", -1))
const _hoisted_39 = {
  key: 1,
  class: "alert alert-success"
}
const _hoisted_40 = {
  key: 2,
  class: "join-action"
}
const _hoisted_41 = { class: "actions" }
const _hoisted_42 = { class: "terms" }

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { reloadApp, usePageTitle } from '@/util/AppUtil'
import { FamilyGroup, InvitationResult } from '@/gp/GroupAdminModel'
import { useFamilyGroupInviteStore } from '@/gp/FamilyGroupInviteStore'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { workspaceTypeInfos } from '@/rd/ResearchDataModel'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { LoadMode } from '@/util/AsyncData'
import { useTokenManager } from "@/auth/TokenManager"
import { DateTime } from 'luxon'
import { getSignInUrlWithRedirect } from '@/util/AppUtil'
import FamilyGroupInviteProfile from './FamilyGroupInviteProfile.vue'
import Spinner from '@/util/Spinner.vue'
import { isDefined } from '@/util/TypeScriptUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupInviteAcceptPage',
  props: {
  inviteId: String,
  inviteCode: String,
},
  setup(__props) {

const props = __props;



usePageTitle("Invitation")

const inviteStore = useFamilyGroupInviteStore()
const userStore = useUserStore()
const familyGroupStore = useFamilyGroupStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const dataGroupStore = useDataGroupStore()
const router = useRouter()
const tokenManager = useTokenManager()

const inviteRef = computed(() => props.inviteId ? inviteStore.getAsyncInviteByCode(props.inviteId, props.inviteCode)?.data : undefined)

const expiredRef = computed(() => !!inviteRef.value?.expirationDate && inviteRef.value.expirationDate < DateTime.utc())
const authUserRef = computed(() => userStore.getAsyncSelf()?.data) // loaded on sign in
const senderUserRef = computed(() => userStore.getAsyncUser(inviteRef.value?.senderUserId)?.data) // loaded with invite
const recipientUserRef = computed(() => userStore.getAsyncUser(inviteRef.value?.recipientUserId)?.data) // loaded with invite
const familyGroupRef = computed(() => familyGroupStore.getAsyncGroup(inviteRef.value?.familyGroupId)?.data) // loaded with invite
const groupOwnerRef = computed(() => userStore.getAsyncUser(familyGroupRef.value?.ownerId)?.data) // loaded with invite
const workspaceDataGroupRef = computed(() => {
  // load research group(s) for this family group using invite code
  const dmKeyList = dataGroupMemberStore.getAsyncKeyListsForFamilyGroups([inviteRef.value?.familyGroupId], LoadMode.EnsureLoaded, props.inviteId, props.inviteCode).at(0)?.data
  const dms = dataGroupMemberStore.getLoadedMembers(dmKeyList?.keys ?? [])
  const dgs = dataGroupStore.getAsyncGroupList(dms.map(dm => dm.dataGroupId)).map(a => a.data).filter(isDefined) // should be loaded
  return dgs.length == 1 ? dgs[0] : undefined
})
const workspaceBaseTypeRef = computed(() => workspaceDataGroupRef.value?.workspaceType?.split('.')[0])
const workspaceProductRef = computed(() => workspaceTypeInfos.find(w => w.id == workspaceBaseTypeRef.value)?.product)
const workspaceNameRef = computed(() => workspaceDataGroupRef.value?.name ?? "(unnamed tree)")
const workspaceOwnerRef = computed(() => userStore.getAsyncUser(workspaceDataGroupRef.value?.ownerId)?.data) // should be loaded

const loadingRef = computed(() => !inviteRef.value)

const differentUserRef = computed(() => !!authUserRef.value?.id && !!inviteRef.value?.recipientUserId && inviteRef.value?.recipientUserId != authUserRef.value.id)
const differentAddressRef = computed(() => !!authUserRef.value?.id && inviteRef.value?.recipientEmail != authUserRef.value?.email)
const alreadyAcceptedRef = computed(() => inviteRef.value?.result == InvitationResult.Accepted)
const closedDateText = computed(() => inviteRef.value?.closedDate?.toLocaleString(DateTime.DATE_FULL))
const resendTextRef = computed(() => busyRef.value ? "Sending..." : "Send updated invitation")
const signInUrlRef = computed(() => getSignInUrlWithRedirect(inviteRef.value?.getAcceptUrl(props.inviteCode) ?? ''))

const addressConfirmedRef = ref(false)
const showConfirmAddressRef = computed(() => differentAddressRef.value && !addressConfirmedRef.value && !notMeRef.value)
const notMeRef = ref(false)

const productLogos: any = { // 'any' prevents TS from complaining about arbitrary string as index
  "RootsMagic": new URL('@/assets/logos/RootsMagic_app.png', import.meta.url).href,
  "Legacy": new URL('@/assets/logos/Legacy_app_circle.png', import.meta.url).href,
}

const workspaceProductIconRef = computed(() => productLogos[workspaceBaseTypeRef.value ?? 'unknown'])

const resentRef = ref(false)
const busyRef = ref(false)

async function resend(e: Event) {
  e.preventDefault()
  busyRef.value = true
  await inviteStore.resendAsync(props.inviteId!, props.inviteCode!)
  resentRef.value = true
  busyRef.value = false
}

async function accept(e: Event) {
  e.preventDefault()
  const tokenResponse = await inviteStore.acceptAsync(props.inviteId!, props.inviteCode!)

  if (tokenResponse) {
    tokenManager.setCurrentTokenFromResponse(tokenResponse)
    reloadApp() // hard navigate after signing in to reload app
  }
  else {
    router.push('/home') // soft navigate if already authenticated
  }
}

/*
GET treexg.com/familygroupinvites/:id?code=123&expand=...
<- confirm page
GET gp.treexg.com/familygroupinvites/:id?code=123
GP: GET id.treexg.com/identities/$lookup [lookup recipient identity by address, fill in recipientUserId if known]
If no auth, confirm: Create new account or sign in (already have an account)?
If already have account, sign in using normal method, return to page with app token
If profile, confirm: Is this profile you?
-- does auth user match profile? either could be "wrong". Which to fix?
If no, give option to cancel or sign in as self
If sign in as self, sign in using normal method, return to page with correct app token
Show: [sender] has invited you to join [family group]
Confirm: Join group?
[if YES]
if user exists, gp issues app token directly w/o involving identity service
if no user, gp creates or looks up identity, then issues app token directly
GET id.treexg.com/
*/


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["accept-page", { loading: loadingRef.value }])
  }, [
    (loadingRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h4", null, [
            _createVNode(Spinner, { color: "#bbb" }),
            _createTextVNode("Looking up your invitation...")
          ])
        ]))
      : (differentUserRef.value || notMeRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
        : (alreadyAcceptedRef.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createElementVNode("p", null, "This invitation from " + _toDisplayString(senderUserRef.value?.displayName) + " was accepted on " + _toDisplayString(closedDateText.value) + ".", 1),
                (authUserRef.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        to: _unref(FamilyGroup).getPageUrl(inviteRef.value?.familyGroupId)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Go to group")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (showConfirmAddressRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", null, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(recipientUserRef.value?.displayName ?? inviteRef.value?.recipientDisplayName) + " (" + _toDisplayString(inviteRef.value?.recipientEmail) + ") ", 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(authUserRef.value?.displayName) + " (" + _toDisplayString(authUserRef.value?.email) + ") ", 1)
                ]),
                _hoisted_16,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (addressConfirmedRef.value = true))
                }, "Continue"),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-inline btn-link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (notMeRef.value = true))
                  }, " No, this invitation is intended for someone else ")
                ])
              ]))
            : (inviteRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(recipientUserRef.value?.displayName ?? inviteRef.value.recipientDisplayName) + " (" + _toDisplayString(inviteRef.value.recipientEmail) + ") ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", null, _toDisplayString(senderUserRef.value?.displayName), 1),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(senderUserRef.value?.email), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(familyGroupRef.value?.name), 1),
                        _createElementVNode("div", _hoisted_32, " Managed by " + _toDisplayString(groupOwnerRef.value?.displayName), 1)
                      ])
                    ])
                  ]),
                  (inviteRef.value?.profileDataGroupId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(FamilyGroupInviteProfile, {
                            "invite-id": inviteRef.value?.id
                          }, null, 8, ["invite-id"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!authUserRef.value && expiredRef.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        (!resentRef.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _hoisted_38,
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: resend
                              }, [
                                (busyRef.value)
                                  ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(resendTextRef.value), 1)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_39, " We sent you an updated invitation with a new link. "))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary",
                          onClick: accept
                        }, " Join group and explore my family tree "),
                        _createElementVNode("div", _hoisted_41, [
                          (!authUserRef.value && !recipientUserRef.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: signInUrlRef.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Join using my existing account")
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true),
                          (!authUserRef.value && !recipientUserRef.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: "/",
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("What is Tree Crossing?")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_42, [
                    _createTextVNode(" By accepting this invitation, you agree to our "),
                    _createVNode(_component_router_link, { to: "/terms" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Terms")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" and "),
                    _createVNode(_component_router_link, { to: "/privacy" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Privacy Policy")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(". ")
                  ])
                ]))
              : _createCommentVNode("", true)
  ], 2))
}
}

})